<div class="shim" *ngIf="active">&nbsp;</div>
<ion-item class="pointer">
    <ion-label>
        <h2>{{user.name}}</h2>
        <p>{{user.email}}</p>
    </ion-label>
    <bb-rating-summary *ngIf="user.averageRating" [rating]="user.averageRating"></bb-rating-summary>
</ion-item>
